import { backColor as backColor_1 } from './backColor.locstring.json';
import loc from 'owa-localize';
import * as React from 'react';
import type { RibbonButton, RibbonDropDownProps } from './RibbonButton';
import { callFormatApi } from 'owa-editor/lib/utils/callApi';
import { BackColorPicker } from 'owa-editor-ribbon-secondary-ui';
import type { ColorPickerItem } from 'owa-color-picker/lib/utils/ColorPickerItem';
import createLivePreviewHandler from 'owa-editor-live-preview/lib/utils/createLivePreviewHandler';
import { isFeatureEnabled } from 'owa-feature-flags';
import setLastBackColor from '../../actions/setLastBackColor';

let styles = require('./colors.scss');

const backColor: RibbonButton = {
    key: 'backColor',
    title: () => loc(backColor_1),
    imageSrc: require('../svg/backcolor.svg'),
    createDropDownCallback: React.memo(
        ({ editorViewState, formatState, target, dismiss }: RibbonDropDownProps) => {
            const onSelect = React.useCallback(
                (color: ColorPickerItem) => {
                    callFormatApi(
                        editorViewState,
                        'setBackgroundColor',
                        [color.colorCode],
                        [color.colorCode.lightModeColor]
                    );
                    setLastBackColor(formatState, color.colorCode);
                },
                [editorViewState]
            );
            const onPreviewSelect = React.useCallback(
                (color: ColorPickerItem) =>
                    callFormatApi(editorViewState, 'setBackgroundColor', [color.colorCode]),
                [editorViewState]
            );
            const livePreview =
                isFeatureEnabled('cmp-live-preview') &&
                createLivePreviewHandler(editorViewState, onPreviewSelect);
            return (
                <BackColorPicker
                    menuTargetElement={target}
                    onDismissMenu={dismiss}
                    onSelectColor={onSelect}
                    shouldFocusOnMount={true}
                    selectedColor={formatState.backgroundColor}
                    livePreview={livePreview}
                />
            );
        }
    ),
};

export default backColor;

export const splittedBackColor: RibbonButton = {
    onExecute: (editorViewState, formatViewState) =>
        callFormatApi(editorViewState, 'setBackgroundColor', [formatViewState.lastBackColors]),
    additionalRenderer: (editorViewState, formatViewState) => (
        <div
            className={styles.colorHint}
            style={{ backgroundColor: formatViewState.lastBackColors.lightModeColor }}
        />
    ),
    ...backColor,
    width: 50,
};
